import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { userOnPaytmMembershipPlanBackend } from './user-on-paytm-membership-plan.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { userOnPaytmMembershipPlanReducer } from './user-on-paytm-membership-plan.reducer';

// FIXME: remove that
backend.userOnPaytmMembershipPlan = userOnPaytmMembershipPlanBackend;

@NgModule({
  imports: [
    StoreModule.forFeature(
      'userOnPaytmMembershipPlan',
      userOnPaytmMembershipPlanReducer,
    ),
    /* DatastoreBackendModule.forFeature(
      'userOnPaytmMembershipPlan',
      userOnPaytmMembershipPlanBackend,
    ),*/
  ],
})
export class DatastoreUserOnPaytmMembershipPlanModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-on-paytm-membership-plan/user-on-paytm-membership-plan.module.ts